import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import {
  CarrierSchema,
  ServiceSchema,
} from "../fulfillments/fulfillment-carriers-and-services";
import { ParcelSchema } from "./parcel";

// Using reserved scan shortcuts is fine, but the user
// Should be informed that presets will always trump
export enum Hotkey {
  CMD_0 = "⌘0",
  CMD_1 = "⌘1",
  CMD_2 = "⌘2",
  CMD_3 = "⌘3",
  CMD_4 = "⌘4",
  CMD_5 = "⌘5",
  CMD_6 = "⌘6",
  CMD_7 = "⌘7",
  CMD_8 = "⌘8",
  CMD_9 = "⌘9",
  A = "⌘A",
  B = "⌘B",
  // C = "⌘c", copy, preventable but people will think its a bug
  D = "⌘D",
  E = "⌘E",
  F = "⌘F",
  G = "⌘G",
  H = "⌘H",
  I = "⌘I", // focus input
  J = "⌘J", // personalized slip
  K = "⌘K",
  // L = "⌘L", focus address bar, unpreventable
  M = "⌘M",
  // N = "⌘N", new window, unpreventable
  O = "⌘O",
  // P = "⌘p", print label
  // Q = "⌘Q", quit, unpreventable
  // R = "⌘r", reload page, unpreventable
  S = "⌘S", // print packing slip
  // T = "⌘T", new tab, unpreventable
  U = "⌘U",
  // V = "⌘v", paste, preventable but people will think its a bug
  // W = "⌘W", close tab, unpreventable
  X = "⌘X",
  Y = "⌘Y",
  Z = "⌘Z",
}

export const reservedScanKeys: Hotkey[] = [Hotkey.I, Hotkey.J, Hotkey.S];

export const getHotkeyDisplayName = (hotkey: Hotkey) => {
  const isMac = navigator.platform.toLowerCase().includes("mac");
  if (!isMac) {
    return hotkey.replace("⌘", "Ctrl ");
  }
  return hotkey.replace("⌘", "⌘ ");
};

export const HotkeySchema = z.enum(Hotkey);

export const PresetSchema = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  hotkey: HotkeySchema,
  carrier: CarrierSchema.nullish(),
  service: ServiceSchema.nullish(),
  parcel: ParcelSchema.nullish(),
  totalWeightInOunces: z.number().nullish(),
});
export type Preset = z.infer<typeof PresetSchema>;
